package com.yogaaicoach.pages.trainingprogram

import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

internal external interface AddNewTrainingSuccessPageProps : Props {
    var onGoToDashboardButtonClicked: () -> Unit
}

// Pixel-matched against AddNewTrainingSuccessScreen.kt: unlike Screens 1-4, this one doesn't
// override LazyPageLayout's maxWidthIn (defaults to 1000dp, not the wizard's usual 600dp) — just
// a centered subtitle and a button back to the dashboard.
internal val AddNewTrainingSuccessPage = FC<AddNewTrainingSuccessPageProps> { props ->
    div {
        className = ClassName("dashboard-page-shell")
        div {
            className = ClassName("wizard-success-page")
            p { className = ClassName("wizard-success-subtitle"); +"Creating a training program might take several minutes." }
            button {
                className = ClassName("primary-button")
                onClick = { props.onGoToDashboardButtonClicked() }
                +"Go to Dashboard >>"
            }
        }
    }
}
